import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedSelect = _resolveComponent("SharedSelect")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('form'))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('group'))
      }, [
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('label'))
        }, _toDisplayString(_ctx.$t("Дата и время")), 3),
        _createVNode(_component_SharedSelect, {
          view: "light",
          options: _ctx.displayedPeriodOptions,
          value: _ctx.selectedPeriod,
          "onUpdate:value": _ctx.handlePeriod
        }, null, 8, ["options", "value", "onUpdate:value"])
      ], 2),
      (_ctx.isDepositWithdrawal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.b('group'))
          }, [
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('label'))
            }, _toDisplayString(_ctx.$t("Тип")), 3),
            _createVNode(_component_SharedSelect, {
              view: "light",
              options: _ctx.displayedTypeOptions,
              value: _ctx.displayedType,
              "onUpdate:value": _ctx.handleType
            }, null, 8, ["options", "value", "onUpdate:value"])
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('group'))
      }, [
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('label'))
        }, _toDisplayString(_ctx.$t("Валюта")), 3),
        _createVNode(_component_SharedSelect, {
          view: "light",
          options: _ctx.displayedCurrencyOptions,
          value: _ctx.displayedCurrency,
          "onUpdate:value": _ctx.handleCurrency
        }, null, 8, ["options", "value", "onUpdate:value"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('group'))
      }, [
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('label'))
        }, _toDisplayString(_ctx.$t("Статус")), 3),
        _createVNode(_component_SharedSelect, {
          view: "light",
          options: _ctx.displayedStatusOptions,
          value: _ctx.displayedStatus,
          "onUpdate:value": _ctx.handleStatus
        }, null, 8, ["options", "value", "onUpdate:value"])
      ], 2)
    ], 2)
  ], 2))
}